/**
 * Where is this app running? (PLAN §7.2)
 *  - a tenant's own domain (tasks.acme.com)                → slug null, router basename "/"
 *  - the temporary link missions.devninjaweb.com/<slug>/…  → slug from the first path segment, basename "/<slug>"
 *  - local dev (localhost)                                 → no path slug (deep links like /inbox must work);
 *    the tenant is sent as the VITE_DEV_TENANT_SLUG hint against the temp host (default "devninjaweb").
 */
const TEMP_HOST = (import.meta.env.VITE_TEMP_LINK_HOST ?? 'missions.devninjaweb.com').toLowerCase();
const DEV_SLUG = import.meta.env.VITE_DEV_TENANT_SLUG ?? 'devninjaweb';
/** Product routes on the temp host that are never tenant slugs. */
const RESERVED = new Set(['claim', 'offer', 'onboard', 'brand', 'assets', 'api']);

export interface TenantLocation {
  host: string;
  slug: string | null;
  basename: string;
}

export function tenantLocation(loc: Pick<Location, 'hostname' | 'pathname'> = window.location): TenantLocation {
  const host = loc.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return { host: TEMP_HOST, slug: DEV_SLUG, basename: '/' };
  if (host !== TEMP_HOST) return { host, slug: null, basename: '/' };
  const first = loc.pathname.split('/')[1]?.toLowerCase() ?? '';
  const slug = first && !RESERVED.has(first) && /^[a-z0-9-]{3,40}$/.test(first) ? first : null;
  return { host, slug, basename: slug ? `/${slug}` : '/' };
}
